import React from 'react';
import List from '../components/ServicesList';
import Payments from '../components/Payments';
import Transfers from '../components/Transfers';
import ApplePay from '../components/ApplePay';
import GooglePay from '../components/GooglePay';
import SafeBoxes from '../components/SafeBoxes';
import Abank24 from '../components/Abank24';
import Leasing from '../components/Leasing';
import Insurance from '../components/Insurance';
import CheckDocument from '../components/CheckDocument';
import PensionProgram from '../components/Pension';
import PersonalData from '../components/PersonalData';
import Abroad from '../components/Abroad';
import '../less/main.less';
import WarTime from '../components/WarTime';
import Policy from "../../Policy";
import GreenPolicy from "../../InsuranceGreenPolicy";
import MobilePay from "../components/MobilePay";
import MiniCasco from "../components/MiniCasco";
import DefenceEveryDay from "../components/DefenceEveryDay";
import Cashback from "../../Business/views/pbpEntity";
import InsuranceTour from "../../InsuranceTour";
import InviteFriend from "../components/InviteFriend";
import CashbackOld from "../components/Сashback";
import DigitalSkins from "../components/DigitalSkins";
import BrokerageServices from "../components/BrokerageServices";
import PersonalInsurance from "../components/PersonalInsurance";
import BenefitsMilitaryPersonnel from "../components/BenefitsMilitaryPersonnel";

export default function template() {
    let Component = null;
    if (this.props.match && this.props.match.params && this.props.match.params.type) {
        switch (this.props.match.params.type) {
            case 'brokerage-services':
              Component = BrokerageServices;
              break;
            case 'digital_skins':
              Component = DigitalSkins;
              break;
            case 'payments':
                Component = Payments;
                break;
            case 'transfers':
                Component = Transfers;
                break;
            case 'apple_pay':
                Component = ApplePay;
                break;
            case 'google_pay':
                Component = GooglePay;
                break;
            case 'mobilepay':
                Component = MobilePay;
                break;
            case 'abank':
                Component = Abank24;
                break;
            case 'safe_boxes':
                Component = SafeBoxes;
                break;
            case 'auto-leasing':
                Component = Leasing;
                break;
            case 'insurance':
                Component = Insurance;
                break;
            case 'document':
                Component = CheckDocument;
                break;
            case 'pension':
                Component = PensionProgram;
                break;
            case 'personal_data':
                Component = PersonalData;
                break;
            case 'if-you-are-abroad':
                Component = Abroad;
            break;
            case 'war-time':
                Component = WarTime;
            break;
            case 'policy':
                Component = Policy;
                break;
            case 'insurance_tour':
                Component = InsuranceTour;
                break;
            case 'green-policy':
                Component = GreenPolicy;
                break;
            case 'mini-casco':
                Component = MiniCasco;
                break;
            case 'defenceeveryday':
                Component = DefenceEveryDay;
                break;
            case 'become-partner':
                Component = Cashback;
                break;
            case 'cashback':
                Component = CashbackOld;
                break;
            case 'invite_friend':
                Component = InviteFriend;
                break;
            case 'personal-insurance':
                Component = PersonalInsurance;
                break;
            case 'benefits-military-personnel':
                Component = BenefitsMilitaryPersonnel;
                break;

            default:
                Component = List;
        }
    } else {
        Component = List;
    }

    return <Component { ...this.props} isCashbackPage={true}  />;
}
